import { useState } from "react";
import i18n from "../../../i18n/i18n";
import "./style.scss";
import { Assets } from "../../../assets";
import { Link, useNavigate } from "react-router";
import { doLogin } from "./core/_request";
import { useResetPasswordStore } from "../forget-password/store/ForgotPasswordStore";
import { Form, Input } from "antd";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../common/components/simpleInput";
import Spinner from "../../../common/components/Spinner/Spinner";
import useAppStore from "../../../store/AppStore";

const LoginWrapper = () => {
  const navigate = useNavigate();
  const { setAuthorizationData } = useAppStore();
  const { setSentEmail } = useResetPasswordStore();
  const [loginError, setLoginError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [form] = Form.useForm();

  const onSubmitLoginHandler = async (values: any) => {
    try {
      setIsLoading(true);
      const loginRes = await doLogin(values);

      if (loginRes && loginRes?.token) {
        setLoginError(null);
        setAuthorizationData(loginRes);
        // navigate("/app/dashboard");
        navigate("/app/welcome");
      } else {
        setLoginError(loginRes?.response?.data?.message ?? "");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content h-100 d-flex align-items-center justify-content-center">
        <div className="login-ctn">
          <div className="d-flex justify-content-end align-items-start p-2">
            <img src={Assets.images.ukas} width={45} alt="ukas" />
            <img src={Assets.images.sgs} width={60} alt="ukas" />
          </div>
          <div className="d-flex justify-content-center pe-1">
            <img src={Assets.imagesSvg.logo} width={"40%"} alt="Logo SEMS" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="w-50 d-flex flex-col">
              <div className="form-container-wrapper">
                {loginError !== null && (
                  <div className="p-3 text-danger  text-center">
                    {loginError}
                  </div>
                )}
                <h6 className="form-header text-primary text-center font-semibold">
                  {i18n.t("LOGIN")}
                </h6>
                <FormProvider
                  Form={Form}
                  form={form}
                  onFinish={(values: any) => {
                    onSubmitLoginHandler(values);
                  }}
                  onFinishFailed={(err) => {
                    console.log("err", err);
                  }}
                >
                  <div className="form-container">
                    <div className="">
                      <SimpleInput
                        Form={Form}
                        name={"identifier"}
                        rules={[
                          {
                            required: true,
                            message: `Ce champ est requis`,
                          },
                          // {
                          //   type: "email",
                          //   message: `Veuillez saisir un email valide`,
                          // },
                        ]}
                        customInput={
                          <Input
                            placeholder={i18n.t("YOUR_EMAIL")}
                            className="input-login"
                          />
                        }
                      />
                    </div>
                    <div className="">
                      <SimpleInput
                        Form={Form}
                        name={"password"}
                        rules={[
                          {
                            required: true,
                            message: `Ce champ est requis`,
                          },
                          {
                            min: 4,
                            message: `Le Mot de passe doit contenir au moins 4 caractères`,
                          },
                        ]}
                        customInput={
                          <Input.Password
                            placeholder={i18n.t("PASSWORD")}
                            className="input-login"
                          />
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <Link
                        to={"/auth/forgot-password"}
                        className="align-self-end text-secondary no-underline"
                        onClick={() => {
                          setSentEmail(false);
                        }}
                      >
                        {i18n.t("FORGOT_PWD")}
                      </Link>
                    </div>
                    <div className="">
                      <button type="submit" className="form-submit-button">
                        {isLoading ? <Spinner /> : i18n.t("LOGIN")}
                        {}
                      </button>
                    </div>
                  </div>
                </FormProvider>
              </div>

              {/* <Form className="w-100 text-center">
                <h6 className="text-primary ">{i18n.t("LOGIN")}</h6>
                {loginError !== null && (
                  <div className="p-3 text-danger">{loginError}</div>
                )}
                <Form.Group className="py-3">item?.holds
                  <Form.Control
                    type={"email"}
                    placeholder={i18n.t("YOUR_EMAIL")}
                    className={"input-login"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value ?? "")}
                    onBlur={onValidateEmail}
                  />
                  {emailError && (
                    <span className="text-danger fs-6">{emailError}</span>
                  )}
                </Form.Group>
                <Form.Group className="py-3">
                  <InputPassword
                    type={"password"}
                    placeholder={i18n.t("PASSWORD")}
                    className="input-login"
                    value={password}
                    onChange={(e) => setPassword(e.target.value ?? "")}
                    onBlur={onValidatePassword}
                  />
                  {passwordError && (
                    <span className="text-danger fs-6">{passwordError}</span>
                  )}
                </Form.Group>
                <div className="d-flex justify-content-end">
                  <Link
                    to={"/auth/forgot-password"}
                    className="align-self-end text-secondary no-underline"
                    onClick={() => {
                      setSentEmail(false);
                    }}
                  >
                    {i18n.t("FORGOT_PWD")}
                  </Link>
                </div>
                <Button
                  type="button"
                  variant="primary"
                  disabled={!isFormValid}
                  className="w-100 mt-3"
                  onClick={onLogin}
                >
                  {i18n.t("LOGIN")}
                </Button>
              </Form> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWrapper;
